import { User } from '@/type';

function normalize(s: string): string {
  return (s || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

interface Keyword {
  raw: string;
  lower: string;
  norm: string;
}

export function prepareKeyword(keyword: string|null): Keyword {
  const raw = (keyword || '').trim();
  return {
    raw,
    lower: raw.toLowerCase(),
    norm: normalize(raw),
  };
}

export function matchesUser(u: User, kw: Keyword): boolean {
  return u.id.toString().includes(kw.raw)
    || normalize(u.firstName).includes(kw.norm)
    || normalize(u.lastName).includes(kw.norm)
    || (u.email || '').toLowerCase().includes(kw.lower);
}
